import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

class ImageBlot extends BlockEmbed {
    static create(value) {
        let node = super.create();

        // Handle if value is a string (just the image URL) or an object
        const url = typeof value === 'string' ? value : value.url;
        const align = value.align || '';  // Default to empty string if no align provided
        const width = value.width;  // Capture the width if provided
        const height = value.height;  // Capture the height if provided

        // Set the image source
        node.setAttribute('src', url);

        // Apply alignment styles (center, left, right)
        if (align) {
            node.style.display = 'block';  // Ensures the image takes up its own block
            node.style.margin = align === 'center' ? '0 auto' : '';
            node.style.float = align !== 'center' ? align : '';
        }

        // Apply size styles if provided
        if (width) {
            node.width = width;
        }
        if (height) {
            node.height = height;
        }

        return node;
    }

    static value(node) {
        return {
            url: node.getAttribute('src'),  // Get the image URL from the node
            align: node.style.float || (node.style.margin === '0 auto' ? 'center' : ''),
            width: node.width,  // Get the width if set
            height: node.height,  // Get the height if set
        };
    }
}

ImageBlot.blotName = 'image';
ImageBlot.tagName = 'img';

export default ImageBlot